import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Spinner,
} from "reactstrap";

import { PIDetailsModel_close } from "../store/SRRequetForQuotation/actions";
import moment from "moment";

class GetPIDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  // componentDidMount() {
  //   this.props.GetMRRowData(this.props.MRid);
  // }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.SRPIDetailsModel}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader toggle={() => this.props.PIDetailsModel_close()}>
            SERVICE INDENT DETAILS ({this.props.PIRowDetails.code})
          </ModalHeader>

          <ModalBody>
            <Row className="p-2">
              <Col md="12" className="p-1 m-0">
                {this.props.loading ? (
                  <>
                    <div className="text-center">
                      <Spinner color="primary" size="">
                        Loading...
                      </Spinner>
                    </div>
                  </>
                ) : (
                  <div className="Order-panel-content">
                    <div className="list-column">
                      <ul className="list-style-three p-0">
                        <li className="clearfix">
                          <span className="ttl">SI Approvals Status:</span>
                          <span className="dtl">
                            <Label
                              className={
                                this.props.PIRowDetails?.sistatus === 1 ||
                                this.props.PIRowDetails?.sistatus === 2
                                  ? "text-primary font-size-16 "
                                  : this.props.PIRowDetails?.sistatus === 3
                                  ? "text-success font-size-16 "
                                  : "text-danger font-size-16"
                              }
                            >
                              {this.props.PIRowDetails?.sistatus_name}
                            </Label>
                          </span>
                        </li>
                        <li className="clearfix">
                          <span className="ttl">HOD(U) Approved by:</span>
                          <span className="dtl">
                            {this.props.PIRowDetails.userDeptApprovedby &&
                              this.props.PIRowDetails.userDeptApprovedby[
                                this.props.PIRowDetails.userDeptApprovedby
                                  .length - 1
                              ]?.approvedby.fullname}
                          </span>
                        </li>
                        <li className="clearfix">
                          <span className="ttl">HOD(U) Approved Date:</span>
                          <span className="dtl">
                            {moment(
                              this.props.PIRowDetails.userDeptApprovedby &&
                                this.props.PIRowDetails.userDeptApprovedby[
                                  this.props.PIRowDetails.userDeptApprovedby
                                    .length - 1
                                ]?.createdon
                            ).format("DD-MM-YYYY")}
                          </span>
                        </li>
                        <li className="clearfix">
                          <span className="ttl">Location:</span>
                          <span className="dtl">
                            {this.props.PIRowDetails.location?.name}
                          </span>
                        </li>

                        <li className="clearfix">
                          <span className="ttl">User Department:</span>
                          <span className="dtl">
                            {this.props.PIRowDetails.userdepartment?.name}
                          </span>
                        </li>
                        <li className="clearfix">
                          <span className="ttl">User Name:</span>
                          <span className="dtl">
                            {this.props.PIRowDetails.createdby?.fullname}
                          </span>
                        </li>
                        <li className="clearfix">
                          <span className="ttl">Submited Date:</span>
                          <span className="dtl">
                            {moment(this.props.PIRowDetails.createdon).format(
                              "DD-MM-YYYY"
                            )}
                          </span>
                        </li>
                        <li className="clearfix">
                          <span className="ttl">Description:</span>
                          <span className="dtl">
                            {this.props.PIRowDetails.description}
                          </span>
                        </li>
                        {this.props.PIRowDetails.sistatus === 4 && (
                          <li className="clearfix">
                            <span className="ttl text-danger ">
                              Reject Remark :
                            </span>
                            <span className="dtl">
                              {
                                this.props.PIRowDetails.sistatus[
                                  this.props.PIRowDetails.sistatus.length -
                                    1
                                ].description
                              }
                            </span>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { SRPIDetailsModel, PIRowDetails, loading } = state.SRRequestForQuotation;

  return {
    SRPIDetailsModel,
    PIRowDetails,
    loading,
  };
};

export default connect(mapStatetoProps, {
  PIDetailsModel_close,
})(GetPIDetails);
